export type RuntimeContext = {
  user?: { id?: string; email?: string; name?: string } | null;
  loan?: { id?: string | null; state?: string | null } | null;
  modal?: { 
    key?: string | null; 
    open?: boolean;
    step?: number | null;
    taskKey?: string | null;
    taskId?: string | null;
    taskName?: string | null;
    taskState?: string | null;
  } | null;
};

let runtimeContext: RuntimeContext = {};

export function setRuntimeContext(partial: Partial<RuntimeContext>): void {
  runtimeContext = { ...runtimeContext, ...partial };
}

export function getRuntimeContext(): RuntimeContext {
  return runtimeContext;
}


